import dayjs from 'dayjs';
import locale from 'dayjs/locale/de';

const today = () => {
  return dayjs().locale({ ...locale });
};

const localize = (day: dayjs.Dayjs) => {
  return day.locale({ ...locale });
};

const endOfCurrentYear = () => {
  return today().endOf('year');
};

const startOfCurrentYear = () => {
  return today().startOf('year');
};

const todayStart = () => {
  return today().startOf('day');
};

const todayEnd = () => {
  return today().endOf('day');
};

const startOfLastMonth = () => {
  return today().subtract(1, 'month').startOf('month');
};
const endOfLastMonth = () => {
  return today().subtract(1, 'month').endOf('month');
};

const firstDayOfCurrentMonth = (date?: dayjs.Dayjs | undefined | null) => {
  const targetDate = date ? date : dayjs();
  return targetDate.locale({ ...locale }).startOf('month');
};

const endOfCurrentMonth = (date?: dayjs.Dayjs | undefined | null) => {
  const targetDate = date ? date : dayjs();
  return targetDate.locale({ ...locale }).endOf('month');
};

const formatAsTitle = (date: string | dayjs.Dayjs | undefined | null, short?: boolean) => {
  let targetDate;
  if (date) {
    if (dayjs.isDayjs(date)) {
      targetDate = date as dayjs.Dayjs;
    } else {
      targetDate = dayjs(date);
    }
  } else {
    targetDate = dayjs();
  }

  return targetDate
    .locale({
      ...locale,
    })
    .format(short ? 'dd DD.MM.' : 'dddd, DD.MMMM'); // Mo 01.01. or Monday, 01.January
};

const stringToDayjs = (date: string | undefined | null) => {
  const targetDate = date ? dayjs(date) : dayjs();
  return targetDate.locale({
    ...locale,
  });
};

const formatStringAsDay = (date: string | undefined | null) => {
  const targetDate = date ? dayjs(date) : dayjs();
  return targetDate
    .locale({
      ...locale,
    })
    .format('YYYY-MM-DD');
};

const anyToDayjs = (date: any) => {
  return dayjs(date).locale({ ...locale });
};

const calculateFromAndTo = (days: dayjs.Dayjs[]): [dayjs.Dayjs, dayjs.Dayjs] => {
  if (days.length > 0) {
    return [days[0], days[days.length - 1]];
  } else {
    return [firstDayOfCurrentMonth(), endOfCurrentMonth()];
  }
};

const firstDayOfWeek = (date?: dayjs.Dayjs | string | undefined | null) => {
  let targetDate;
  if (date) {
    if (dayjs.isDayjs(date)) {
      targetDate = date as dayjs.Dayjs;
    } else {
      targetDate = dayjs(date);
    }
  } else {
    targetDate = dayjs();
  }

  return targetDate.locale({ ...locale }).startOf('week');
};

const startOfMonthByDay = (date: dayjs.Dayjs) => {
  return date.startOf('month');
};

const endOfMonthByDay = (date: dayjs.Dayjs) => {
  return date.endOf('month');
};

const dateByMonthAndYear = (month: number, year: number) => {
  return dayjs().year(year).month(month);
};

const monthStringByNumber = (month: number) => {
  return dayjs()
    .locale({
      ...locale,
    })
    .month(month)
    .format('MMMM');
};
const isFuture = (date: dayjs.Dayjs) => {
  return date.isAfter(today());
};

export default {
  todayStart,
  todayEnd,
  endOfCurrentYear,
  firstDayOfCurrentMonth,
  endOfCurrentMonth,
  formatAsTitle,
  stringToDayjs,
  formatStringAsDay,
  anyToDayjs,
  calculateFromAndTo,
  firstDayOfWeek,
  startOfCurrentYear,
  startOfLastMonth,
  endOfLastMonth,
  localize,
  startOfMonthByDay,
  endOfMonthByDay,
  dateByMonthAndYear,
  monthStringByNumber,
  isFuture,
};
